import '@/assets/styles/components/radio-group.styles.scss';
import clsx from 'clsx';

interface RadioOption {
	value: string;
	label: string;
}

interface RadioGroupProps {
	options: RadioOption[];
	value?: string;
	selectedValues?: string[];
	onChange: (value: string) => void;
	name: string;
	multiple?: boolean;
	direction?: 'vertical' | 'horizontal';
}

export const RadioGroup = ({ options, value, selectedValues = [], onChange, name, multiple = false, direction = 'horizontal' }: RadioGroupProps) => {
	const isSelected = (optionValue: string) => {
		if (multiple) {
			return selectedValues.includes(optionValue);
		}
		return value === optionValue;
	};

	return (
		<div className={clsx('radio-group', direction === 'horizontal' ? 'direction-horizontal' : 'direction-vertical')}>
			{options.map(option => (
				<label
					key={option.value}
					className={`radio-option ${isSelected(option.value) ? 'selected' : ''}`}>
					<input
						type={multiple ? 'checkbox' : 'radio'}
						name={name}
						value={option.value}
						checked={isSelected(option.value)}
						onChange={() => onChange(option.value)}
						className="radio-input"
					/>
					<div className={multiple ? 'checkbox-mark' : 'radio-circle'} />
					<span className="radio-label">{option.label}</span>
				</label>
			))}
		</div>
	);
};
